import API from "../Services/API";
import Model from "./Model";
import State from "./State";

const activeStatuses = ['Initiated', 'Active'];

const useSubscription = (alwaysRefresh) => {
    const ret = Model({
        alwaysRefresh,
        stateKey: ['marketplace', 'subscription'],
        fetchData: () => API.get('/marketplace/subscription'),
        returnDataKey: 'subscription',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    const sub = opts.model();
                    return opts.wrapUpdateCall(
                        () => API.post(
                            '/marketplace/subscription/' + sub.id,
                            Object.assign({}, sub, data, {outwards: null})
                        ),
                        'Patch updated',
                        true,
                    );
                },
                updateLeadGeneration: (data) => {
                    const sub = opts.model();
                    const url = `/marketplace/subscription/${sub.id}/${data.autoPurchase ? 'initiate' : 'cancel'}`;
                    return opts.wrapUpdateCall(
                        () => API.post(url, {}),
                        `Lead generation ${data.autoPurchase ? 'started' : 'stopped'}`,
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading your marketplace subscription.',
    });



    return {
        ...ret,
        isLeadGenActive: ret.subscription && activeStatuses.includes(ret.subscription.status),
    }
}

const useLeads = (distance, alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['leads', distance ?? 'area'],
        fetchData: () => API.get('/marketplace/' + (distance ? 'nearby?withinMiles='+distance : 'area')).catch(() => []),
        returnDataKey: 'leads',
        saveAdditionalData: (response) => {
            response.map((lead) => {
                State.putIfNotExists(['leads', lead.id], lead);
                return lead;
            });
        },
        registerAdditionalMethods: (opts) => {
            return {
                purchaseLead: (leadId) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/marketplace/lead/' + leadId + '/purchase'),
                        'Lead purchased',
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Failed to load leads.',
    });
}

const useLead = (leadId, alwaysRefresh) => {
    return Model({
        alwaysRefresh,
        stateKey: ['leads', leadId],
        fetchData: () => API.get('/marketplace/lead/' + leadId),
        returnDataKey: 'lead',
        defaultLoadingError: 'Failed to load lead details.',
    });
}

export {
    useSubscription,
    useLeads,
    useLead,
};
